import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { INotificationList } from 'src/app/interface/notification/i-notfication';
import { AjaxResponseInterface } from 'src/app/interface/global/AjaxResponseInterface';

@Injectable({
  providedIn: 'root',
})
export class UserNotificationsService {
  private readonly notificationListBaseUrl = environment.apiUrl + '/notification-list';

  constructor(private readonly http: HttpClient) {}

  getNotificationList(payload: any): Observable<AjaxResponseInterface<INotificationList[]>> {
    return this.http.post<AjaxResponseInterface<INotificationList[]>>(
      `${this.notificationListBaseUrl}/`,
      payload
    );
  }

  removeNotification(notificationId: string, status: number): Observable<AjaxResponseInterface<any>> {
    return this.http.post<AjaxResponseInterface<any>>(
      `${this.notificationListBaseUrl}/update?_id=${notificationId}`,
      { status }
    );
  }

  getUnreadNotificationCount(payload: any): Observable<AjaxResponseInterface<number>> {
    return this.http.post<AjaxResponseInterface<number>>(
      `${this.notificationListBaseUrl}/count`,
      payload
    );
  }

  markAllNotificationsAsRead(): Observable<AjaxResponseInterface<any>> {
    return this.http.post<AjaxResponseInterface<any>>(
      `${this.notificationListBaseUrl}/read`,
      {}
    );
  }
}

